import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link, NavLink } from 'react-router-dom';
import MenuLineButton from './MenuLineButton';

const MenuHeadItem = (props) => {
    const [styleState, setStyleState] = useState({
        onOfmenu: 'dashboard__btn-chevron rotate-180',
        onOfopacity: 'dashboard__submenu',
        onOfmenu2: 'dashboard__btn-chevron ',
        onOfopacity2: 'dashboard__submenu max-height-0 opacity-0',
    });
    const [isExpand, setExpand] = useState(false);
    const [isButton, setButton] = useState(false);
    const [isChosen, setChosen] = useState(false);
    useEffect(() => {
        if (props.tittle.navigatorLine != undefined) {
            if (props.isShowArrow == props.tittle.navigatorLine) {
                setExpand(true);
            } else {
                setExpand(false);
            }
        }
        if (props.tittle.line != undefined) {
            Object.entries(props.tittle.line).map(([key, value]) => {
                if (value[1] == props.isShowArrow) {
                    setExpand(true);
                }
            });
        }
    }, [props.expand]);

    useEffect(() => {
        if (props.tittle.line != undefined) {
            setButton(true);
        } else {
            setButton(false);
        }
    });
    useEffect(() => {
        if (props.tittle.line != undefined) {
            if (props.tittle.line == props.isShowArrow) {
                setChosen(true);
            } else {
                setChosen(false);
            }
        } else {
            if (props.tittle.navigatorLine == props.isShowArrow) {
                setChosen(true);
            } else {
                setChosen(false);
            }
        }
    }, [props.isShowArrow]);
    function expandManuItem() {
        if (isExpand) {
            setExpand(false);
        } else {
            setExpand(true);
        }
        props.setExpandedManuItem();
    }

    return (
        <>
            {props.tittle.navigatorLine == undefined ? (
                <li key={props.tittle.head} className="dashboard__menu-item borderUP">
                    <button className="dashboard__btn dashboard__btn--expand colorEDS">
                        <span>
                            <span className="dashboard__btn-icon aa">{props.icon}</span>
                            <span
                                onClick={() => {
                                    expandManuItem();
                                }}
                                className=" "
                                style={{fontWeight: props.expandedManuItem? "700":"", color: props.expandedManuItem? "#000":""}}
                            >
                                {props.tittle.head}
                            </span>
                        </span>
                        <svg
                            className={
                                props.expandedManuItem ? styleState.onOfmenu : styleState.onOfmenu2
                            }
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => {
                                expandManuItem();
                            }}
                        >
                            <path
                                d="M6 9L12 15L18 9"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                    <ul
                        className={
                            props.expandedManuItem
                                ? styleState.onOfopacity
                                : styleState.onOfopacity2
                        }
                    >
                        {Object.entries(props.tittle.line).map(([key, value],i) => {
                    
                            return (
                                <MenuLineButton
                                    key={key  + i + value}
                                    keyId={key  + i + value}
                                    expandedManuItem={props.expandedManuItem}
                                    setExpandedManuItem={props.setInside}
                                    tittle={value[0]}
                                    link={value[1]}
                                    isArrow={props.isShowArrow}
                                    showArrow={props.showArrow}
                                />
                            );
                        })}
                    </ul>
                </li>
            ) : (
                <li key={props.tittle.head} className="dashboard__menu-item">
                    <NavLink to={props.tittle.navigatorLine}>
                        <button className="dashboard__btn dashboard__btn--expand colorEDS"
                        onClick={()=>{
                            expandManuItem();
                        }}>
                            <span>
                                <span className="dashboard__btn-icon">{props.icon}</span>
                                <span className="" style={{fontWeight: props.expandedManuItem? "700":"", color: props.expandedManuItem? "#000":""}}
                                >{props.tittle.head}</span>
                            </span>
                            
                        </button>
                    </NavLink>
                </li>
            )}
        </>
    );
};

export default MenuHeadItem;
